import { render, staticRenderFns } from "./exchangerForm.vue?vue&type=template&id=27fdfc64&"
import script from "./exchangerForm.vue?vue&type=script&lang=js&"
export * from "./exchangerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports